module.exports = __webpack_public_path__ + "img/郑州办公室.fa507e52.jpg";